import { Numeric } from "@salaxy/core";
/**
 * Formats value as percent
 * @param value Number to be formatted to percent
 * @param options Options for decimals and nullChar
 * @returns Provided value as percent
 */
export function hbsHelperP(value: string | number, options: any): string {
  const params = options && options.hash ? options.hash : options;
  return (value || value === 0) ? (params && ( params.dec || params.dec === 0 || params.dec === null)) ? Numeric.formatPercent((Numeric.parseNumber(value) ?? 0) * 100.0, params.dec) : Numeric.formatPercent((Numeric.parseNumber(value) ?? 0) * 100.0) : ((params && params.nullChar) ? params.nullChar : "-");
}